module.exports = __webpack_public_path__ + "img/5.d1f91783.jpg";